<template>
  <yd-dialog title="新增工单" :visible.sync="addVisible" append-to-body @close="closeAdd">
    <div>
      <el-form
        ref="ruleForm"
        v-if="!['6', '7', '8', '9', '10'].includes(paramForm.typeId)"
        :rules="rules"
        :model="paramForm"
        class="demo-form-inline"
        size="small"
        label-position="right"
        label-width="100px"
      >
        <el-form-item label="工单类型：" prop="typeId">
          <el-cascader
            v-model="paramForm.typeId"
            :options="treeList"
            clearable
            :props="{
              expandTrigger: 'hover',
              value: 'id',
              label: 'name',
              children: 'childWorkOrderType',
              emitPath: false
            }"
            ref="cascader"
            @change="handleChange"
            style="width: 200px"
          />

          <div v-if="tips" class="font-12 color-redFont flex" style="margin-left: -80px">
            <div style="line-height: 20px">填写说明：</div>
            <div v-html="tips" class="richText"></div>
          </div>
        </el-form-item>
        <template v-if="!['6', '7'].includes(paramForm.typeId)">
          <el-form-item v-if="paramForm.typeId" label="工单内容：" prop="content">
            <el-input
              type="textarea"
              v-model="paramForm.content"
              clearable
              placeholder="请输入工单内容"
              maxlength="500"
              show-word-limit
              :rows="5"
              style="width: 400px"
            />
          </el-form-item>
          <el-form-item v-if="paramForm.typeId" label="图片：">
            <upload-image
              code="work-order"
              ref="uploadImage"
              :quality="0.8"
              @input="handleSuccess"
              :limit="20"
            />
          </el-form-item>
          <el-form-item v-if="paramForm.typeId" label="附件：">
            <file-upload
              code="work-order"
              @input="handleFileSuccess"
              :list="fileList"
              :limit="10"
            />
          </el-form-item>
          <el-divider v-if="paramForm.typeId" />
          <el-form-item
            v-if="paramForm.typeId && templateList"
            label="下载模版："
            class="templateList"
          >
            <div v-for="item in templateList" :key="item.url">
              <span class="color-666 text-eli margin-right-10" style="width: 250px">{{
                item.fileName
              }}</span>
              <a :href="item.fileUrl" download style="color: #409eff" class="margin-left-10 pointer"
                >下载</a
              >
            </div>
          </el-form-item>
        </template>
      </el-form>
      <el-form
        ref="ruleForm"
        v-if="['6', '7', '8', '9', '10'].includes(paramForm.typeId)"
        :rules="rules"
        :model="contentForm"
        class="demo-form-inline"
        size="small"
        label-position="right"
        label-width="100px"
      >
        <el-form-item label="工单类型：" prop="typeId">
          <el-cascader
            v-model="paramForm.typeId"
            :options="treeList"
            clearable
            :props="{
              expandTrigger: 'hover',
              value: 'id',
              label: 'name',
              children: 'childWorkOrderType',
              emitPath: false
            }"
            ref="cascader"
            @change="handleChange"
            style="width: 200px"
          />
        </el-form-item>
        <el-form-item v-if="paramForm.typeId === '6'" label="姓名：" prop="username">
          <el-input
            v-model.trim="contentForm.username"
            clearable
            placeholder="请输入姓名"
            style="width: 200px"
          />
        </el-form-item>
        <el-form-item v-else label="账号：" prop="name">
          <el-select
            v-model="contentForm.merchantIds"
            @change="getUser"
            filterable
            style="width: 250px"
            placeholder="请选择部门"
          >
            <el-option
              v-for="item in merchantDic"
              :key="item.id"
              :label="item.merchantName"
              :value="item.id"
            />
          </el-select>
          <el-select
            style="width: 150px; margin-left: 10px"
            placeholder="请选择对应人员"
            filterable
            v-model="contentForm.username"
          >
            <el-option
              @click.native="onUserChange(item)"
              v-for="item in userList"
              :label="item.userName"
              :value="item.userName"
              :key="item.userId"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="paramForm.typeId === '6' || userInfo.mobilePhone"
          label="手机号："
          prop="phone"
        >
          <span v-if="!phoneEdit && paramForm.typeId === '7'">{{ userInfo.mobilePhone }}</span>
          <el-input
            v-else
            v-model.trim="contentForm.phone"
            clearable
            placeholder="请输入手机号"
            style="width: 200px"
          />
          <el-button
            v-if="paramForm.typeId === '7'"
            type="text"
            @click="phoneEdit = !phoneEdit"
            class="margin-x-10"
            >{{ phoneEdit ? '取消' : '编辑' }}</el-button
          >
        </el-form-item>
        <!-- <el-form-item label="密码：" prop="password">
        <el-input
          type="password"
          v-model="paramForm.password"
          clearable
          placeholder="请输入6-16位密码"
          maxlength="16"
          style="width: 200px"
          auto-complete="new-password"
        />
      </el-form-item> -->
        <el-form-item
          v-if="paramForm.typeId === '6' || userInfo.mobilePhone"
          label="所属公司："
          prop="merchantId"
        >
          <span v-if="!merchantEdit && paramForm.typeId === '7'">{{ userInfo.merchantName }}</span>
          <el-select
            v-else
            v-model="contentForm.merchantId"
            filterable
            placeholder="请选择"
            clearable
            style="width: 200px"
          >
            <el-option
              v-for="item in merchantDic"
              :key="item.id"
              :label="item.merchantName"
              :value="item.id"
              @click.native="labelClick(item.merchantName)"
            />
          </el-select>
          <el-button
            v-if="paramForm.typeId === '7'"
            type="text"
            @click="handleEdit(1)"
            class="margin-x-10"
            >{{ merchantEdit ? '取消' : '编辑' }}</el-button
          >
        </el-form-item>
        <el-form-item
          v-if="paramForm.typeId === '6' || userInfo.mobilePhone"
          label="所属角色："
          prop="role"
        >
          <span v-if="!rolesEdit && paramForm.typeId === '7'">{{
            userInfo.rolesNames || '-'
          }}</span>
          <el-select
            v-else
            v-model="contentForm.role"
            placeholder="请选择角色"
            filterable
            multiple
            clearable
            style="width: 200px"
            @change="roleChange"
          >
            <el-option
              v-for="item in roleList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
          <el-button
            v-if="paramForm.typeId === '7'"
            type="text"
            @click="handleEdit(2)"
            class="margin-x-10"
            >{{ rolesEdit ? '取消' : '编辑' }}</el-button
          >
        </el-form-item>
        <div v-if="['8', '9', '10'].includes(paramForm.typeId)">
          <el-form-item
            :label="
              paramForm.typeId === '8'
                ? '封禁原因'
                : paramForm.typeId === '9'
                ? '解封原因'
                : '删除原因'
            "
            prop="reason"
          >
            <el-input
              type="textarea"
              v-model="contentForm.reason"
              clearable
              :placeholder="`请输入${
                paramForm.typeId === '8'
                  ? '封禁原因'
                  : paramForm.typeId === '9'
                  ? '解封原因'
                  : '删除原因'
              }`"
              maxlength="500"
              show-word-limit
              :rows="5"
              style="width: 400px"
            />
          </el-form-item>
          <template v-if="paramForm.typeId === '8'">
            <el-form-item label="封禁时间" prop="enableTime">
              <el-date-picker
                v-model="contentForm.enableTime"
                type="date"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptions"
                placeholder="请选择生效日期"
              />
            </el-form-item>
          </template>
          <template v-if="paramForm.typeId === '9'">
            <el-form-item label="解封时间" prop="enableTime2">
              <el-date-picker
                v-model="contentForm.enableTime2"
                type="date"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptions"
                placeholder="请选择生效日期"
              />
            </el-form-item>
          </template>
          <el-form-item label="" v-if="paramForm.typeId === '8' || paramForm.typeId === '9'">
            <p style="color: #999; font-size: 12px; margin: -20px 0 0 0"
              >若不选择生效日期，审核通过后，即刻生效</p
            >
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div v-if="paramForm.typeId">
      <div class="font-light margin-left-30 margin-bottom-10">流程：</div>
      <el-timeline class="process">
        <el-timeline-item hide-timestamp placement="top">
          <div>待审核</div>
          <div>审核部门：{{ auditDepartment || '-' }}</div>
        </el-timeline-item>
        <el-timeline-item hide-timestamp placement="top"> 提交工单 </el-timeline-item>
      </el-timeline>
    </div>
    <div slot="footer">
      <el-button @click="closeAdd">取 消</el-button>
      <el-button type="primary" @click="submitForm" :disabled="!paramForm.typeId">保 存</el-button>
    </div>
  </yd-dialog>
  <!-- <el-dialog
    title="新增工单"
    :visible.sync="addVisible"
    append-to-body
    destroy-on-close
    @close="closeAdd"
  >
    <el-form
      ref="ruleForm"
      v-if="!['6', '7', '8', '9', '10'].includes(paramForm.typeId)"
      :rules="rules"
      :model="paramForm"
      class="demo-form-inline"
      size="small"
      label-position="right"
      label-width="100px"
    >
      <el-form-item label="工单类型：" prop="typeId">
        <el-cascader
          v-model="paramForm.typeId"
          :options="treeList"
          clearable
          :props="{
            expandTrigger: 'hover',
            value: 'id',
            label: 'name',
            children: 'childWorkOrderType',
            emitPath: false
          }"
          ref="cascader"
          @change="handleChange"
          style="width: 200px"
        />

        <div v-if="tips" class="font-12 color-redFont flex" style="margin-left: -80px">
          <div style="line-height: 20px">填写说明：</div>
          <div v-html="tips" class="richText"></div>
        </div>
      </el-form-item>
      <template v-if="!['6', '7'].includes(paramForm.typeId)">
        <el-form-item v-if="paramForm.typeId" label="工单内容：" prop="content">
          <el-input
            type="textarea"
            v-model="paramForm.content"
            clearable
            placeholder="请输入工单内容"
            maxlength="500"
            show-word-limit
            :rows="5"
            style="width: 400px"
          />
        </el-form-item>
        <el-form-item v-if="paramForm.typeId" label="图片：">
          <upload-image ref="uploadImage" :quality="0.8" @input="handleSuccess" :limit="20" />
        </el-form-item>
        <el-form-item v-if="paramForm.typeId" label="附件：">
          <file-upload @input="handleFileSuccess" :list="fileList" :limit="10" />
        </el-form-item>
        <el-divider v-if="paramForm.typeId" />
        <el-form-item
          v-if="paramForm.typeId && templateList"
          label="下载模版："
          class="templateList"
        >
          <div v-for="item in templateList" :key="item.url">
            <span class="color-666 text-eli margin-right-10" style="width: 250px">{{
              item.fileName
            }}</span>
            <a
              :href="item.fileUrl"
              target="_blank"
              style="color: #409eff"
              class="margin-left-10 pointer"
              >下载</a
            >
          </div>
        </el-form-item>
      </template>
    </el-form>
    <el-form
      ref="ruleForm"
      v-if="['6', '7', '8', '9', '10'].includes(paramForm.typeId)"
      :rules="rules"
      :model="contentForm"
      class="demo-form-inline"
      size="small"
      label-position="right"
      label-width="100px"
    >
      <el-form-item label="工单类型：" prop="typeId">
        <el-cascader
          v-model="paramForm.typeId"
          :options="treeList"
          clearable
          :props="{
            expandTrigger: 'hover',
            value: 'id',
            label: 'name',
            children: 'childWorkOrderType',
            emitPath: false
          }"
          ref="cascader"
          @change="handleChange"
          style="width: 200px"
        />
      </el-form-item>
      <el-form-item v-if="paramForm.typeId === '6'" label="姓名：" prop="username">
        <el-input
          v-model.trim="contentForm.username"
          clearable
          placeholder="请输入姓名"
          style="width: 200px"
        />
      </el-form-item>
      <el-form-item v-else label="账号：" prop="name">
        <el-select
          v-model="contentForm.merchantIds"
          @change="getUser"
          filterable
          style="width: 250px"
          placeholder="请选择部门"
        >
          <el-option
            v-for="item in merchantDic"
            :key="item.id"
            :label="item.merchantName"
            :value="item.id"
          />
        </el-select>
        <el-select
          style="width: 150px; margin-left: 10px"
          placeholder="请选择对应人员"
          filterable
          v-model="contentForm.username"
        >
          <el-option
            @click.native="onUserChange(item)"
            v-for="item in userList"
            :label="item.userName"
            :value="item.userName"
            :key="item.userId"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        v-if="paramForm.typeId === '6' || userInfo.mobilePhone"
        label="手机号："
        prop="phone"
      >
        <span v-if="!phoneEdit && paramForm.typeId === '7'">{{ userInfo.mobilePhone }}</span>
        <el-input
          v-else
          v-model.trim="contentForm.phone"
          clearable
          placeholder="请输入手机号"
          style="width: 200px"
        />
        <el-button
          v-if="paramForm.typeId === '7'"
          type="text"
          @click="phoneEdit = !phoneEdit"
          class="margin-x-10"
          >{{ phoneEdit ? '取消' : '编辑' }}</el-button
        >
      </el-form-item> -->
  <!-- <el-form-item label="密码：" prop="password">
        <el-input
          type="password"
          v-model="paramForm.password"
          clearable
          placeholder="请输入6-16位密码"
          maxlength="16"
          style="width: 200px"
          auto-complete="new-password"
        />
      </el-form-item> -->
  <!-- <el-form-item
        v-if="paramForm.typeId === '6' || userInfo.mobilePhone"
        label="所属公司："
        prop="merchantId"
      >
        <span v-if="!merchantEdit && paramForm.typeId === '7'">{{ userInfo.merchantName }}</span>
        <el-select
          v-else
          v-model="contentForm.merchantId"
          filterable
          placeholder="请选择"
          clearable
          style="width: 200px"
        >
          <el-option
            v-for="item in merchantDic"
            :key="item.id"
            :label="item.merchantName"
            :value="item.id"
            @click.native="labelClick(item.merchantName)"
          />
        </el-select>
        <el-button
          v-if="paramForm.typeId === '7'"
          type="text"
          @click="handleEdit(1)"
          class="margin-x-10"
          >{{ merchantEdit ? '取消' : '编辑' }}</el-button
        >
      </el-form-item>
      <el-form-item
        v-if="paramForm.typeId === '6' || userInfo.mobilePhone"
        label="所属角色："
        prop="role"
      >
        <span v-if="!rolesEdit && paramForm.typeId === '7'">{{ userInfo.rolesNames || '-' }}</span>
        <el-select
          v-else
          v-model="contentForm.role"
          placeholder="请选择角色"
          filterable
          multiple
          clearable
          style="width: 200px"
          @change="roleChange"
        >
          <el-option v-for="item in roleList" :key="item.id" :label="item.name" :value="item.id" />
        </el-select>
        <el-button
          v-if="paramForm.typeId === '7'"
          type="text"
          @click="handleEdit(2)"
          class="margin-x-10"
          >{{ rolesEdit ? '取消' : '编辑' }}</el-button
        >
      </el-form-item>
      <div v-if="['8', '9', '10'].includes(paramForm.typeId)">
        <el-form-item
          :label="
            paramForm.typeId === '8'
              ? '封禁原因'
              : paramForm.typeId === '9'
              ? '解封原因'
              : '删除原因'
          "
          prop="reason"
        >
          <el-input
            type="textarea"
            v-model="contentForm.reason"
            clearable
            :placeholder="`请输入${
              paramForm.typeId === '8'
                ? '封禁原因'
                : paramForm.typeId === '9'
                ? '解封原因'
                : '删除原因'
            }`"
            maxlength="500"
            show-word-limit
            :rows="5"
            style="width: 400px"
          />
        </el-form-item>
        <template v-if="paramForm.typeId === '8'">
          <el-form-item label="封禁时间" prop="enableTime">
            <el-date-picker
              v-model="contentForm.enableTime"
              type="date"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
              placeholder="请选择生效日期"
            />
          </el-form-item>
        </template>
        <template v-if="paramForm.typeId === '9'">
          <el-form-item label="解封时间" prop="enableTime2">
            <el-date-picker
              v-model="contentForm.enableTime2"
              type="date"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
              placeholder="请选择生效日期"
            />
          </el-form-item>
        </template>
        <el-form-item label="" v-if="paramForm.typeId === '8' || paramForm.typeId === '9'">
          <p style="color: #999; font-size: 12px; margin: -20px 0 0 0"
            >若不选择生效日期，审核通过后，即刻生效</p
          >
        </el-form-item>
      </div>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeAdd">取 消</el-button>
      <el-button type="primary" @click="submitForm" :disabled="!paramForm.typeId">保 存</el-button>
    </div>
  </el-dialog> -->
</template>

<script>
  import { ref, reactive, computed, onMounted, nextTick } from '@vue/composition-api'
  import UploadImage from '@/components/ImageUpload'
  import { getSysUserByMerchantId, getWorkTypeTree, workOrderSave } from '@/api/workOrder'
  import { getRoleListForSelect } from '@/api/role/role'
  import { getMerchantSelect } from '@/api/transport/bustime'
  import FileUpload from '@/components/FileUpload'
  import { cloneDeep, isEmpty } from 'lodash-es'
  import { useFetchData } from '@/hooks'
  import { Message, Loading } from 'element-ui'

  export default {
    props: {
      visible: {
        type: Boolean,
        default: false
      }
    },
    components: {
      UploadImage,
      FileUpload
    },
    setup(props, { emit }) {
      const rules = {
        content: [{ required: true, message: '请输入工单内容', trigger: 'blur' }],
        type: [{ required: true, message: '请选择工单类型', trigger: 'change' }],
        username: [{ required: true, message: '请填写姓名', trigger: 'blur' }],
        phone: [
          { required: true, message: '请填写正确手机号码', trigger: 'blur', pattern: /^[0-9]*$/ },
          { min: 11, max: 11, message: '请输入11位手机号', trigger: 'blur' }
        ],
        password: [{ required: true, message: '请填写密码', trigger: 'blur' }],
        merchantId: [{ required: true, message: '请选择所属公司', trigger: 'change' }],
        role: [{ required: true, message: '请选择所属角色', trigger: 'change' }],
        name: [{ required: true, message: '请选择账号', trigger: 'change' }],
        reason: [{ required: true, message: '请输入原因', trigger: 'blur' }]
      }
      const { resData: merchantDic } = useFetchData(getMerchantSelect, {})
      const { resData: regionTreeData } = useFetchData(getWorkTypeTree, {})
      const { resData: roleList } = useFetchData(getRoleListForSelect, {})

      const ruleForm = ref(null)
      const tips = ref('')
      const templateList = ref([])
      const userList = ref([])
      const cascader = ref(null)
      const userInfo = ref({})
      const paramForm = ref({})
      const addVisible = ref(false)
      const merchantEdit = ref(false)
      const phoneEdit = ref(false)
      const rolesEdit = ref(false)
      const auditDepartment = ref('')
      const contentForm = ref({
        userId: '',
        username: '',
        name: '',
        phone: '',
        password: '',
        merchantEdit: false,
        phoneEdit: false,
        rolesEdit: false,
        merchantName: '',
        merchantId: '',
        merchantIds: '',
        role: [],
        rolesName: '',
        reason: '',
        enableTime: '',
        enableTime2: ''
      })
      const contentEnum = {
        username: '姓名',
        phone: '手机号',
        password: '密码',
        merchantName: '所属公司',
        rolesName: '所属角色',
        name: '账号',
        reason: '原因',
        enableTime: '封禁时间',
        enableTime2: '解封时间'
      }
      const download = (url) => {
        window.open(url)
      }

      const closeAdd = () => {
        emit('close')
        addVisible.value = false
        paramForm.value = {}
        clearForm()
        phoneEdit.value = false
        rolesEdit.value = false
        merchantEdit.value = false
      }
      const submitForm = async () => {
        ruleForm.value.validate((vaild) => {
          if (vaild) {
            if (['6', '7', '8', '9', '10'].includes(paramForm.value.typeId)) {
              const form = cloneDeep(contentForm.value)
              if (['7', '8', '9', '10'].includes(paramForm.value.typeId)) {
                delete form.username
              }
              if (paramForm.value.typeId === '7') {
                if (!merchantEdit.value) {
                  delete form.merchantName
                }
                if (!phoneEdit.value) {
                  delete form.phone
                }
                if (!rolesEdit.value) {
                  delete form.rolesName
                }
              }
              if (['6', '7'].includes(paramForm.value.typeId)) {
                paramForm.value.sysUserVo = contentForm.value
              }
              if (paramForm.value.typeId === '7') {
                paramForm.value.bizLinkId = contentForm.value.userId
              }
              paramForm.value.content = convertObjectToString(form)
              paramForm.value.keyword = contentForm.value.phone
            }
            paramForm.value.channel = 2
            handleWorkOrderSave(paramForm.value)
          } else {
            return false
          }
        })
      }
      const handleWorkOrderSave = async (value) => {
        Loading.service()
        const { code } = await workOrderSave(value)
        if (code === 0) {
          Message({
            message: '提交成功，已通知审核人！',
            type: 'success'
          })
          closeAdd()
          emit('reset')
        }
        Loading.service().close()
      }

      const convertObjectToString = (obj) => {
        let result = ''
        for (const [k, v] of Object.entries(obj)) {
          if (contentEnum[k] && v) {
            result += contentEnum[k] + '：' + v + '\n'
          }
        }
        return result
      }
      // 修改账号所属供应商或所属角色
      const handleEdit = (type) => {
        if (type === 1) {
          merchantEdit.value = !merchantEdit.value
          if (!merchantEdit.value) {
            contentForm.value.merchantId = userInfo.value.merchantId
          }
          return
        }
        rolesEdit.value = !rolesEdit.value
        if (!rolesEdit.value && userInfo.value.roleInfoVoList) {
          contentForm.value.role = userInfo.value.roleInfoVoList.map((obj) => {
            return obj.roleId
          })
        }
      }
      // 图片上传成功
      const handleSuccess = (file) => {
        paramForm.value.pictureUrl = file
      }
      // 文件上传成功
      const handleFileSuccess = (fileList) => {
        console.log(fileList)
        paramForm.value.file = fileList.map((item) => {
          return {
            fileName: item.name,
            fileUrl: item.url
          }
        })
      }

      // 根据供应商获取用户
      const getUser = async (merchantId) => {
        userInfo.value = {}
        contentForm.value.username = ''
        if (!merchantId) {
          return
        }
        const { code, data } = await getSysUserByMerchantId(merchantId)
        if (code === 0) {
          if (paramForm.value.typeId === '7' || paramForm.value.typeId === '8') {
            userList.value = data.filter((item) => item.enable === 1 && item.isDelete === 1)
            return
          }
          if (paramForm.value.typeId === '9') {
            userList.value = data.filter((item) => item.enable === 0 && item.isDelete === 1)
            return
          }
          if (paramForm.value.typeId === '10') {
            userList.value = data.filter((item) => item.enable === 1 && item.isDelete === 1)
            return
          }
        }
        userInfo.value = {}
      }
      // 修改账号选择账号
      const onUserChange = (item) => {
        contentForm.value.userId = item.userId
        contentForm.value.name = item.userName
        contentForm.value.phone = item.mobilePhone
        contentForm.value.merchantId = item.merchantId
        ruleForm.value.clearValidate()
        if (paramForm.value.typeId !== '7') return
        phoneEdit.value = false
        rolesEdit.value = false
        merchantEdit.value = false
        userInfo.value = item
        if (!isEmpty(item.roleInfoVoList)) {
          contentForm.value.role = item.roleInfoVoList.map((obj) => {
            return obj.roleId
          })
          const list = item.roleInfoVoList.map((obj) => {
            return obj.roleName
          })
          userInfo.value.rolesNames = list.join(',')
        } else {
          contentForm.value.role = []
        }
      }
      const clearForm = () => {
        contentForm.value = {
          userId: '',
          username: '',
          name: '',
          phone: '',
          merchantName: '',
          merchantId: '',
          merchantIds: '',
          role: [],
          rolesName: '',
          reason: '',
          enableTime: '',
          enableTime2: ''
        }
        phoneEdit.value = false
        rolesEdit.value = false
        merchantEdit.value = false
      }
      // 获取选中工单类型节点的模版文件
      const handleChange = (value) => {
        clearForm()
        nextTick(() => {
          ruleForm.value.clearValidate()
        })
        if (cascader.value.getCheckedNodes()[0]) {
          const nodesInfo = cascader.value.getCheckedNodes()[0]
          if (nodesInfo.data) {
            tips.value = nodesInfo.data.remark
            templateList.value = nodesInfo.data.templateUrl
            auditDepartment.value = nodesInfo.data.auditDepartment || ''
          }
        }
      }
      // 获取选中的供应商名字
      const labelClick = (label) => {
        if (label) {
          contentForm.value.merchantName = label
          return
        }
        contentForm.value.merchantName = ''
      }
      // 获取选中角色名字
      const roleChange = (val) => {
        if (isEmpty(val)) {
          contentForm.value.rolesName = ''
          return
        }
        const name = []
        roleList.value.forEach((item) => {
          if (val.includes(item.id)) {
            name.push(item.name)
          }
        })
        contentForm.value.rolesName = name.join(',')
      }

      // 工单类型树
      const treeList = computed(() => {
        if (isEmpty(regionTreeData.value)) {
          return []
        }
        regionTreeData.value.forEach((item) => {
          if (isEmpty(item.childWorkOrderType)) {
            item.childWorkOrderType = undefined
          } else {
            item.childWorkOrderType = item.childWorkOrderType.filter(
              (obj) => !['3', '4', '27'].includes(obj.id) && obj.status === 1
            )
            item.childWorkOrderType.forEach((obj) => {
              if (isEmpty(obj.childWorkOrderType)) {
                obj.childWorkOrderType = undefined
              }
            })
            if (isEmpty(item.childWorkOrderType)) {
              item.childWorkOrderType = undefined
            }
          }
        })
        const list = regionTreeData.value.filter((item) => item.status === 1)
        return list
      })

      // 生效日期
      const pickerOptions = reactive({
        // 限制只能选择 >  今天
        disabledDate: (time) => {
          const startDate = new Date().getTime()
          return startDate > time.getTime()
        }
      })

      onMounted(() => {
        addVisible.value = props.visible
      })
      return {
        pickerOptions,
        download,
        ruleForm,
        tips,
        merchantDic,
        treeList,
        userList,
        roleList,
        cascader,
        paramForm,
        contentForm,
        labelClick,
        addVisible,
        closeAdd,
        submitForm,
        rules,
        handleChange,
        templateList,
        getUser,
        onUserChange,
        userInfo,
        handleSuccess,
        handleFileSuccess,
        handleEdit,
        merchantEdit,
        phoneEdit,
        rolesEdit,
        roleChange,
        auditDepartment
      }
    }
  }
</script>

<style lang="scss" scoped>
  ::v-deep .templateList {
    .el-form-item__label {
      font-weight: 700;
    }
  }
  ::v-deep .richText {
    width: 80%;
    line-height: 20px;
    * {
      margin: 0;
      line-height: 20px;
    }
  }
</style>
